/* ==========================================================================
   SmartCourt — sc- interactions
   Rules followed here:
     · server-rendered markup, JS only toggles visibility / sorts / fetches
     · no framework, no build step, defensive against missing sections
   ========================================================================== */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) {
    return Array.prototype.slice.call((r || document).querySelectorAll(s));
  };

  /* ---------------------------------------------------------------- utils -- */
  function money(n, cur) {
    var v = Number(n);
    if (!isFinite(v)) return '';
    return (cur || '$') + v.toLocaleString('en-US', {
      minimumFractionDigits: v % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    });
  }

  /* ============================================================== finder === */
  /* 3-step model: sport -> budget -> must-have. Filters the pre-rendered
     cards that live inside the section (no data fetching, no re-render).     */
  function initFinder(root) {
    var steps = $$('[data-sc-step]', root);
    var panels = $$('[data-sc-panel]', root);
    var cards = $$('[data-sc-fcard]', root);
    var out = $('[data-sc-fout]', root);
    var emptyMsg = $('[data-sc-fempty]', root);
    var countEl = $('[data-sc-fcount]', root);
    var back = $('[data-sc-fback]', root);
    var next = $('[data-sc-fnext]', root);
    var reset = $('[data-sc-freset]', root);
    if (!cards.length) return;

    var state = { sport: '', price: '', feature: '' };
    var idx = 0;

    function matches(c) {
      if (state.sport && c.dataset.sport !== state.sport) return false;
      if (state.price) {
        var p = Number(c.dataset.price);
        var band = state.price;
        if (band === '0-600' && !(p < 600)) return false;
        if (band === '600-1000' && !(p >= 600 && p < 1000)) return false;
        if (band === '1000-1500' && !(p >= 1000 && p < 1500)) return false;
        if (band === '1500+' && !(p >= 1500)) return false;
      }
      if (state.feature && (c.dataset.features || '').indexOf(state.feature) === -1) return false;
      return true;
    }

    function render() {
      var n = 0;
      cards.forEach(function (c) {
        var ok = matches(c);
        c.classList.toggle('is-hidden', !ok);
        if (ok) n++;
      });
      if (countEl) countEl.textContent = n + (n === 1 ? ' machine' : ' machines');
      if (emptyMsg) emptyMsg.hidden = n !== 0;
      if (out) out.hidden = n === 0;
    }

    function show(i) {
      idx = Math.max(0, Math.min(i, panels.length - 1));
      panels.forEach(function (p, k) { p.classList.toggle('on', k === idx); });
      steps.forEach(function (s, k) {
        s.setAttribute('aria-selected', k === idx ? 'true' : 'false');
        s.classList.toggle('done', k < idx);
      });
      if (back) back.style.visibility = idx === 0 ? 'hidden' : 'visible';
      if (next) next.style.visibility = idx === panels.length - 1 ? 'hidden' : 'visible';
    }

    root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-sc-chip]');
      if (chip && root.contains(chip)) {
        var key = chip.dataset.key;
        var val = chip.dataset.value;
        var grp = chip.closest('[data-sc-chips]');
        if (key === 'feature' || key === 'sport' || key === 'price') {
          var was = state[key] === val;
          state[key] = was ? '' : val;
          if (grp) {
            $$('[data-sc-chip]', grp).forEach(function (o) {
              o.classList.remove('on');
              o.setAttribute('aria-pressed', 'false');
            });
          }
          if (!was) {
            chip.classList.add('on');
            chip.setAttribute('aria-pressed', 'true');
          }
        }
        render();
        return;
      }
      var s = e.target.closest('[data-sc-step]');
      if (s && root.contains(s)) { show(Number(s.dataset.scStep)); return; }
      if (e.target.closest('[data-sc-fnext]')) { show(idx + 1); }
      if (e.target.closest('[data-sc-fback]')) { show(idx - 1); }
      if (e.target.closest('[data-sc-freset]')) {
        state = { sport: '', price: '', feature: '' };
        $$('[data-sc-chip]', root).forEach(function (o) {
          o.classList.remove('on');
          o.setAttribute('aria-pressed', 'false');
        });
        show(0);
        render();
      }
    });

    show(0);
    render();
    var n0 = cards.length;
    if (countEl) countEl.textContent = n0 + (n0 === 1 ? ' machine' : ' machines');
  }

  /* ============================================================ grid filter */
  function initGrid(root) {
    var cards = $$('[data-sc-gcard]', root);
    if (!cards.length) return;
    var countEl = $('[data-sc-gcount]', root);
    var empty = $('[data-sc-gempty]', root);
    var sel = $('[data-sc-gsort]', root);
    var grid = $('[data-sc-ggrid]', root);
    var rail = $('[data-sc-rail]', root);
    var railTog = $('[data-sc-railtog]', root);
    var railMeta = $('[data-sc-railmeta]', root);
    var counts = $$('[data-sc-bcount]', root);
    var KEYS = ['sport', 'brand'];
    var active = { sport: '', brand: '' };

    /* Per-brand totals under the current sport filter, so the rail answers
       "which makers actually build a machine for the discipline I picked". */
    function tally() {
      var by = { '': 0 };
      cards.forEach(function (c) {
        if (active.sport && c.dataset.sport !== active.sport) return;
        by['']++;
        var b = c.dataset.brand || '';
        by[b] = (by[b] || 0) + 1;
      });
      return by;
    }

    /* One place that owns every element bound to a filter key: whatever moved
       the state, the rail, the chips and the counts all agree afterwards.
       (Server-rendered markup already carries the "All" state for no-JS.) */
    function syncUI() {
      KEYS.forEach(function (k) {
        $$('[data-sc-filter="' + k + '"]', root).forEach(function (o) {
          var on = (o.dataset.value || '') === active[k];
          o.classList.toggle('on', on);
          o.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });

      var by = tally();
      counts.forEach(function (el) {
        var k = el.dataset.scBcount || '';
        var n = by[k] || 0;
        el.textContent = n;
        var item = el.closest('[data-sc-filter="brand"]');
        /* dim, never hide: the rail must not reflow under the pointer */
        if (item) item.classList.toggle('is-zero', n === 0 && k !== '');
      });

      if (railMeta) {
        var makers = Object.keys(by).filter(function (k) { return k && by[k]; });
        var t = by[''] || 0;
        railMeta.textContent = t + (t === 1 ? ' machine' : ' machines') +
          ' \u00b7 ' + makers.length + (makers.length === 1 ? ' brand' : ' brands');
      }
    }

    function apply() {
      var n = 0;
      cards.forEach(function (c) {
        var ok = (!active.sport || c.dataset.sport === active.sport) &&
                 (!active.brand || c.dataset.brand === active.brand);
        c.classList.toggle('is-hidden', !ok);
        if (ok) n++;
      });
      if (countEl) countEl.textContent = n + (n === 1 ? ' result' : ' results');
      if (empty) empty.hidden = n !== 0;
      syncUI();
    }

    function sort() {
      if (!sel || !grid) return;
      var mode = sel.value;
      var list = cards.slice();
      list.sort(function (a, b) {
        var pa = Number(a.dataset.price), pb = Number(b.dataset.price);
        if (mode === 'price-asc') return pa - pb;
        if (mode === 'price-desc') return pb - pa;
        if (mode === 'name') return (a.dataset.title || '').localeCompare(b.dataset.title || '');
        if (mode === 'brand') {
          var r = (a.dataset.brand || '').localeCompare(b.dataset.brand || '');
          return r || pa - pb;
        }
        return Number(b.dataset.features ? b.dataset.features.split(',').length : 0) -
               Number(a.dataset.features ? a.dataset.features.split(',').length : 0);
      });
      list.forEach(function (c) { grid.appendChild(c); });
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sc-filter]');
      if (!b || !root.contains(b)) return;
      var key = b.dataset.scFilter;
      var val = b.dataset.value || '';
      active[key] = active[key] === val ? '' : val;
      apply();
    });

    /* Below 900px the rail collapses to a drawer; CSS owns the breakpoint, JS
       only flips the state class and the label. */
    if (railTog && rail) {
      railTog.addEventListener('click', function () {
        var open = rail.classList.toggle('is-open');
        railTog.setAttribute('aria-expanded', open ? 'true' : 'false');
        var lbl = $('[data-sc-railtogtext]', railTog);
        if (lbl) lbl.textContent = open ? 'Hide brands' : 'Show brands';
      });
    }

    if (sel) sel.addEventListener('change', function () { sort(); apply(); });
    apply();
  }

  /* ========================================================== compare table */
  function initCompare(root) {
    var host = $('[data-sc-cmp]', root);
    var url = root.dataset.json;
    if (!host) return;
    var tabs = $$('[data-sc-ctab]', root);
    var cur = 'tennis';
    var selected = [];
    var picker = $('[data-sc-cpicker]', root);
    var status = $('[data-sc-cstatus]', root);

    function build(data) {
      var prods = data.products || [];
      var list = prods.filter(function (p) {
        return cur === 'all' ? true : p.sport === cur;
      });
      if (!list.length) {
        host.innerHTML = '<tbody><tr><td class="sc-empty">No machines in this sport.</td></tr></tbody>';
        return;
      }
      if (!selected.length) selected = list.slice(0, 3).map(function (p) { return p.handle; });
      if (picker) picker.innerHTML = list.map(function (p) { return '<label class="sc-cmp__choice"><input type="checkbox" data-sc-choice value="' + esc(p.handle) + '"' + (selected.indexOf(p.handle) !== -1 ? ' checked' : '') + '> ' + esc(p.title) + '</label>'; }).join('');
      list = list.filter(function (p) { return selected.indexOf(p.handle) !== -1; });
      if (status) status.textContent = list.length + ' of 3 machines selected. Choose up to three; scroll the table sideways on smaller screens.';
      var rows = data.rows;
      var head = '<thead><tr><th>Specification</th>' + list.map(function (p) {
        return '<th scope="col"><span class="sc-cmp__b">' + esc(p.brand) + '</span><a href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
               '<div class="sc-cmp__price">' + priceOf(p, data) + '</div></th>';
      }).join('') + '</tr></thead>';
      var body = '<tbody>' + rows.map(function (r) {
        return '<tr><th scope="row">' + esc(r) + '</th>' + list.map(function (p) {
          return '<td>' + esc(p.cells[r] || '—') + '</td>';
        }).join('') + '</tr>';
      }).join('') + '</tbody>';
      host.innerHTML = head + body;
    }

    function priceOf(p, data) {
      var live = (window.SC_CMP_PRICES || {})[p.handle];
      if (live) return esc(live);
      return (Number(p.price_max) > Number(p.price_min) ? 'From ' : '') + money(p.price_min);
    }

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    function bind(data) {
      if (window.SC_CMP_PRICES) data.products = data.products.filter(function (p) { return Object.prototype.hasOwnProperty.call(window.SC_CMP_PRICES, p.handle); });
      var allTab = $('[data-sc-ctab="all"]', root);
      if (allTab) allTab.textContent = 'All ' + data.products.length;
      root.addEventListener('change', function (e) {
        if (!e.target.matches('[data-sc-choice]')) return;
        var box = e.target;
        if (box.checked && selected.length >= 3) { box.checked = false; if (status) status.textContent = 'Choose up to three machines. Deselect one first.'; return; }
        if (!box.checked && selected.length === 1) { box.checked = true; if (status) status.textContent = 'Keep at least one machine selected.'; return; }
        selected = box.checked ? selected.concat([box.value]) : selected.filter(function (h) { return h !== box.value; });
        build(data);
      });
      host._data = data;
      build(data);
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          cur = t.dataset.scCtab; selected = [];
          tabs.forEach(function (o) { o.classList.toggle('on', o === t); });
          build(data);
        });
      });
    }

    /* Inlined dataset wins: the standalone preview cannot fetch over file:// */
    if (window.SC_CMP_DATA) { bind(window.SC_CMP_DATA); return; }
    if (!url) return;

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(bind)
      .catch(function () {
        host.innerHTML = '<tbody><tr><td class="sc-empty">' +
          'Comparison data unavailable.</td></tr></tbody>';
      });
  }

  /* =================================================================== boot */
  /* The buying guide uses native <details>, so it needs no JS binding. */
  function boot() {
    $$('[data-sc-finder]').forEach(initFinder);
    $$('[data-sc-gridroot]').forEach(initGrid);
    $$('[data-sc-cmproot]').forEach(initCompare);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
